// @ts-check
export class CameraODImage {
  /**
   * @param {number} id
   * @param {string} original
   * @param {string} output
   * @param {string[]} labels
   * @param {string} cameraId
   * @param {ObjectDetails[]} objects
   * @param {Date} date
   */
  constructor(id, original, output, type, labels, objects, cameraId, date) {
    /** @type {number} */
    this.id = id;

    /** @type {string} */
    this.name = this.#parseName(original);

    /** @type {string} */
    this.original = original;

    /** @type {string} */
    this.output = output;

    /** @type {string[]} */
    this.labels = Array.from(new Set(labels));

    /** @type {ObjectDetails[]} */
    this.objects = objects;

    /** @type {Date} */
    this.date = date;

    /** @type {string} */
    this.type = type;

    this.cameraId = cameraId;
  }

  // @ts-ignore
  #parseName = (url) => new URL(url).pathname.split("/").pop();

  static fromApi = CameraODImageMapper;
}

/**
 * @param {{ _id: number, id: number, s3_key: string, s3_key_output: string,type:string, objects: any[], labels: string[],camera_id:string, created_at: string, actions: any,detection_size:string }} _
 * @param {number} index
 */
function CameraODImageMapper(
  { _id, id, s3_key, s3_key_output, labels, type, objects, actions, camera_id, created_at },
  index
) {
  if (!_id) _id = id;
  return new CameraODImage(
    _id,
    s3_key,
    s3_key_output, // FIXME: use s3_key_output instead of s3_key (now s3_key for testing purposes only)
    type,
    labels,
    objects?.map(ObjectDetails.fromApi),
    camera_id,
    new Date(actions?.producer_time_fragment ?? created_at)
  );
}

class ObjectDetails {
  constructor(x, y, width, height, size, confidence, label, points, number_of_points, customData) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.size = size;
    this.confidence = confidence;
    this.label = label;
    this.points = points;
    this.numberOfPoints = number_of_points;
    this.customData = customData;
  }

  static fromApi = ({ w, h, min_x, min_y, size, confidence, label, points, number_of_points, ...customData }) =>
    new ObjectDetails(min_x, min_y, w, h, size, confidence, label, points, number_of_points, customData);
}
